module.exports = __webpack_public_path__ + "media/images/games/k2reveal/house-f64f6775c9653c3146facd5ed7e431cd.png";